<mat-stepper [animationDuration]="'150'" [disableRipple]="true" linear>
  <!--  STEP 1 - DATA PRODUCT -->
  <mat-step [stepControl]="fbProductForm" label="Data Produk">
    <form [formGroup]="fbProductForm">
      <app-table-edit-publish-request (dataVariantList)="getVariantList($event)" [brandName]="DetailProduct.value?.name ?? ''"></app-table-edit-publish-request>

      <app-card cardClasses="mt-10" [cardBodyClasses]="'p-18'">
        <ng-container cardBody>
          <app-skeleton-text [height]="25" [isLoading]="isLoading" [width]="230">
            <h2 class="mb-20">Lengkapi Data Produk</h2>
          </app-skeleton-text>

          <ng-container *ngTemplateOutlet="editProductSkeletonLoader"></ng-container>

          <div (ngSubmit)="handleSubmit()" *ngIf="!isLoading.value" [formGroup]="fbProductForm" class="form form-group-edit-publish">
            <app-input-list-box
              [chipsListData]="valuePlantType"
              [UrlEndpoint]="ENDPOINT_PLANT_TYPE"
              [required]="true"
              ctaLabelAddItems="Tambahkan"
              ctaLabelOpenModalForm="Pilih Jenis Tanaman"
              formControlName="plant_type"
              label="Jenis Tanaman"
              modalConfirmTitle="Pilih Jenis Tanaman"
              ngDefaultControl
              searchLabel="Jenis Tanaman"
              title="Jenis Tanaman"
            >
            </app-input-list-box>

            <app-input-list-box
              [chipsListData]="valueTarget"
              [UrlEndpoint]="ENDPOINT_TARGET_LIST"
              [required]="true"
              ctaLabelAddItems="Tambahkan"
              ctaLabelOpenModalForm="Pilih Jenis Sasaran"
              formControlName="pest_target"
              label="Sasaran"
              modalConfirmTitle="Pilih Jenis Sasaran"
              ngDefaultControl
              searchLabel="Sasaran"
              title="Sasaran"
            >
            </app-input-list-box>

            <app-input-list-box
              [UrlEndpoint]="ENDPOINT_MATERIAL_ACTIVE"
              [chipsListData]="valueMaterialActive"
              [required]="true"
              ctaLabelAddItems="Tambahkan"
              ctaLabelOpenModalForm="Pilih Bahan Aktif"
              formControlName="material_active"
              label="Bahan Aktif"
              modalConfirmTitle="Pilih Bahan Aktif"
              ngDefaultControl
              searchLabel="Bahan Aktif"
              title="Bahan Aktif"
            >
            </app-input-list-box>

            <div>
              <label class="mb-5">Deskripsi Produk *</label>
              <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="desc" [toolbar]="toolbar"> </ngx-editor-menu>
                <ngx-editor
                  [editor]="desc"
                  [disabled]="false"
                  [placeholder]="'Deskripsi Produk...'"
                  formControlName="description"
                ></ngx-editor>
              </div>
<!--              <ckeditor [config]="config" formControlName="description" ngDefaultControl></ckeditor>-->
            </div>

            <div>
              <label class="mb-5">Penggunaan Produk *</label>
              <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="product" [toolbar]="toolbar"> </ngx-editor-menu>
                <ngx-editor
                  [editor]="product"
                  [disabled]="false"
                  [placeholder]="'Penggunaan Produk...'"
                  formControlName="product_usage"
                ></ngx-editor>
              </div>
<!--              <ckeditor [config]="config" formControlName="product_usage" ngDefaultControl></ckeditor>-->
            </div>
          </div>
        </ng-container>
      </app-card>

      <div class="d-flex align-items-center justify-content-end mt-10">
        <ng-container [ngTemplateOutlet]="matNextStepTpl" [ngTemplateOutletContext]="{ disableButtonState: fbProductForm.invalid }"></ng-container>
      </div>
    </form>
  </mat-step>

  <!--  STEP 2 - FOTO PRODUCT -->
  <mat-step label="Foto Produk">
    <app-card cardClasses="mt-10" [cardBodyClasses]="'p-18'">
      <ng-container cardBody>
        <app-skeleton-text [height]="25" [isLoading]="isLoading" [width]="230">
          <h2 class="mb-20">Lengkapi Foto Produk <sup class="text-danger">*</sup></h2>
        </app-skeleton-text>

        <ng-container *ngIf="variantList | async">
          <ng-container *ngFor="let variant of variantList.value; index as i">
            <div class="row">
              <div class="col-lg-4 my-4">
                <span>{{ variant['product_name'] }}</span>
                <ng-container *ngIf="isNeedPublished && variantImageData.length">
                  <p *ngIf="variantImageData[i].product_images.length < 1" class="fs-6 fw-lighter mt-1">
                    <span class="fst-italic text-danger">Minimal 1 foto.</span>
                  </p>
                </ng-container>
              </div>
              <div class="col-lg-8 my-4">
                <app-multiple-image-upload
                  (fileUrl)="handleFileUrl($event, variant['product_id'])"
                  (removeFile)="handleRemoveFileUrl($event)"
                  [idx]="variant['product_id']"
                  [data]="variantImageToData(variantList.value[i].product_id, variantList.value[i].product_images)"
                ></app-multiple-image-upload>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </app-card>
    <div class="d-flex align-items-center justify-content-between mt-10">
      <ng-container *ngIf="isNeedPublished && hasSetupReward; else defaultCtaTpl">
        <ng-container [ngTemplateOutlet]="matPrevStepTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="matNextStepTpl" [ngTemplateOutletContext]="{ disableButtonState: !checkVariantImageData() }"></ng-container>
      </ng-container>

      <ng-template #defaultCtaTpl>
        <ng-container [ngTemplateOutlet]="matPrevStepTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="submitPublishTpl" [ngTemplateOutletContext]="{ disableButtonState: !checkVariantImageData() }"></ng-container>
      </ng-template>
    </div>
  </mat-step>

  <!--  STEP 3 - REWARD PRODUCT -->
  <mat-step label="Reward Produk" *ngIf="hasSetupReward">
    <form [formGroup]="fbRewardForm">
      <app-card cardClasses="mt-10" [cardBodyClasses]="'p-18'">
        <ng-container cardBody>
          <app-skeleton-text [height]="25" [isLoading]="isLoading" [width]="230">
            <h2 class="form-title mb-7">Lengkapi Reward Produk</h2>
          </app-skeleton-text>

          <app-note-view
            [color]="'info'"
            [text]="'Pastikan data kupon produk yang diinput benar. Setelah dikonfirmasi, kupon produk akan aktif.'"
            [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"
            [classNoteView]="'mb-10'"
          ></app-note-view>

          <app-input-select-material
            [label]="'Periode'"
            [optionsData]="listPeriodeSubject"
            [readOnly]="hasSetupReward"
            placeholder="Silahkan pilih periode reward"
            formControlName="id_periode"
            ngDefaultControl
          ></app-input-select-material>

          <div class="d-flex flex-wrap w-100 align-items-center mb-6">
            <div class="col-form-label col-12 col-lg-4">
              <label [class.required]="rewardCouponQty.value > 0 || !!rewardDocument.value">Jumlah Kupon Retailer</label>
              <span
                class="svg-icon icon-note-view ms-3 cursor-pointer"
                inlineSVG="{{ STRING_CONSTANTS.ICON.IC_INFO }}"
                ngbPopover="Jumlah scan QR produk untuk mendapatkan 1 Maxxi Poin"
                popoverClass="tooltip-info text-primary"
                placement="bottom"
              ></span>
            </div>
            <div class="ocl-12 col-lg-8">
              <app-input-counter
                [counterPrefix]="{ show: true, label: 'kupon' }"
                [max]="99"
                [required]="!!rewardDocument.value"
                formControlName="qty"
                ngDefaultControl
              ></app-input-counter>
            </div>
          </div>

          <app-document-upload
            [type]="'FILE'"
            formControlName="document"
            (documentOutput)="handleDocument($event)"
            (loadingState)="handleLoadingDocument($event)"
            [isDisabled]="rewardPeriode.invalid"
            [required]="rewardCouponQty.value > 0"
            ngDefaultControl
          ></app-document-upload>
        </ng-container>
      </app-card>

      <div class="d-flex align-items-center justify-content-between mt-10">
        <ng-container [ngTemplateOutlet]="matPrevStepTpl"></ng-container>
        <ng-container [ngTemplateOutlet]="submitPublishTpl" [ngTemplateOutletContext]="{ disableButtonState: fbRewardForm.invalid || (isLoading | async) }"></ng-container>
      </div>
    </form>
  </mat-step>

  <ng-template let-index="index" matStepperIcon="edit">
    {{ index + 1 }}
  </ng-template>
  <ng-template matStepperIcon="done">
    <mat-icon>done</mat-icon>
  </ng-template>

  <ng-template #matNextStepTpl let-isDisable="disableButtonState">
    <button [disabled]="isDisable" class="btn btn-primary px-14" matStepperNext type="button">Selanjutnya</button>
  </ng-template>

  <ng-template #matPrevStepTpl>
    <button class="btn btn-outline btn-before px-14" matStepperPrevious type="button">Sebelumnya</button>
  </ng-template>

  <ng-template #submitPublishTpl let-isDisable="disableButtonState">
    <button (click)="handleSubmit()" [disabled]="isDisable" class="btn btn-primary px-14" type="submit">Publish</button>
  </ng-template>
</mat-stepper>

<app-modal #modalConfirm [callbackSubmit]="submitForm" [modalConfig]="modalConfig" [modalOptions]="{ size: 'md' }">
  <div class="text-center">
    Apakah anda yakin mempublish produk <span class="fw-bold">{{ DetailProduct.value?.name }}</span
    >?<br />
    Produk yang dipublish akan masuk ke dalam katalog distributor dan sales. Pastikan produk yang anda input sudah benar.
  </div>
</app-modal>

<app-modal #modalConfirmEdit [callbackSubmit]="submitForm" [modalConfig]="modalConfigEdit">
  <div class="text-center">
    Apakah anda yakin merubah data <span class="fw-bold">{{ DetailProductUpdateResponse.value?.name }}</span
    >?
  </div>
  <br />
  <div class="text-center">Semua data yang berada di distributor dan sales akan berubah. Pastikan data yang anda input sudah benar.</div>
</app-modal>

<ng-template #editProductSkeletonLoader>
  <div *ngIf="isLoading.value" class="loading_edit_product">
    <div class="row loader_custom">
      <div class="col-lg-4">
        <app-skeleton-text></app-skeleton-text>
      </div>
      <div class="col-lg-8">
        <app-skeleton-text [count]="3" [height]="160" [width]="160"></app-skeleton-text>
        <app-skeleton-text [count]="3" [height]="160" [width]="160"></app-skeleton-text>
      </div>
    </div>
    <div class="row loader_custom">
      <div class="col-lg-4">
        <app-skeleton-text></app-skeleton-text>
      </div>
      <div class="col-lg-8">
        <app-skeleton-text [count]="3" [height]="45" [width]="200"></app-skeleton-text>
      </div>
    </div>
    <div class="row loader_custom">
      <div class="col-lg-4">
        <app-skeleton-text></app-skeleton-text>
      </div>
      <div class="col-lg-8">
        <app-skeleton-text [count]="3" [height]="45" [width]="200"></app-skeleton-text>
      </div>
    </div>
    <div class="row loader_custom">
      <div class="col-lg-4">
        <app-skeleton-text></app-skeleton-text>
      </div>
      <div class="col-lg-8">
        <app-skeleton-text [height]="45" [width]="800"></app-skeleton-text>
        <app-skeleton-text [height]="45" [width]="800"></app-skeleton-text>
      </div>
    </div>
    <div class="row loader_custom">
      <app-skeleton-text></app-skeleton-text>
      <app-skeleton-text [height]="300" [width]="1400"></app-skeleton-text>
    </div>
    <div class="row loader_custom">
      <app-skeleton-text></app-skeleton-text>
      <app-skeleton-text [height]="300" [width]="1400"></app-skeleton-text>
    </div>
  </div>
</ng-template>
